const languageDropdown = document.querySelector('.language-dropdown');

if (languageDropdown) {
  attachEvent('.language-dropdown__trigger', 'click', (ev) => {
    const isOpen = document.body.classList.contains('is-open-language');
    toggleLanguageClass(!isOpen);

    if (windowWidth() < breakpointMd) {
      const parent = ev.target.closest('.language-dropdown');
      const dropdown = parent.querySelector('.language-dropdown__list');
      slideToggle(dropdown, 300, 'block');
    }
    ev.preventDefault();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      toggleLanguageClass(false);
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.language-dropdown')) {
      toggleLanguageClass(false);
    }
  });
}
